import Vue from 'vue';
import { marked } from 'marked';
import { cleanUrl, escape } from 'marked/src/helpers';

const localLinks = /^([a-zA-Z-]+$)|#/;

marked.use({
  renderer: {
    link(href, title, text) {
      const pureHref = cleanUrl(
        this.options.sanitize, this.options.baseUrl,
        href,
      );

      if (pureHref === null) {
        return text;
      }

      let out = `<a href="${escape(pureHref)}"`;

      if (title) {
        out += ` title="${title}"`;
      }

      if (!localLinks.test(pureHref)) {
        out += ' target="_blank"';
      }

      out += `>${text}</a>`;

      return out;
    },
  },
});

marked.setOptions({
  silent: process.env.NODE_ENV === 'production',
});

Vue.component('Markdown', {
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  created() {
    this.emit = this.emit.bind(this);
  },
  mounted() {
    Array.from(this.$el.querySelectorAll('a[href], a[href]'))
      .forEach(element => element.addEventListener('click', this.emit));
  },
  render(h, context) {
    return h('div', { domProps: { innerHTML: marked(this.content) } });
  },
  methods: {
    emit(e) {
      e.stopPropagation();
    },
  },
});
